import React from 'react';

import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import { customEvent } from '@utils/customEvent';

import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './TopicCustomComponent.less';
export default class TopicCustomComponent extends React.Component {
  state = {
    articleList: [],
  }

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let that = this,
      comData = pageInstance.data.eles[compindex],
      customFeature = comData.customFeature,
      listId = customFeature.id,
      style = comData.style,
      listParam = {
        page: 1,
        page_size: customFeature.loadingNum || 10,
        orderby: 'comment_count',
        article_style: 1,
        section_id: customFeature.bindPlate || '',
        category_id: customFeature.bindTopic || '',
        search_value: ''
      },
      listStatus = {
        loading: false,
        isMore: true
      },
      topicSuspension = {
        isShow: customFeature.isShowSuspension,
        topBtnShow: false
      },
      topicPhoneModal = {
        isShow: false,
        phone: ''
      },
      topicReplyComment = {
        index: '',
        isShow: false,
        focus: false,
        keyboardHeight: '50%',
        hasTabBar: app.isTabBarPage(app.getPageRouter()),
        commentContentMaxHeight: 0,
        commentContentHeight: 40
      },
      topicReplyParam = {
        text: '',
        agent_user_token: '',
        address: '',
        latitude: '',
        longitude: '',
        comment_img_url: '',
        comment_id: 0,
        parent_comment_id: 0,
        article_id: '',
        sub_app_id: ''
      },
      newdata = {};

    // 设置param
    let param = customFeature;
    pageInstance.setData({
      ['eles[' + compindex + '].param']: param
    });
    // 找到当前话题排序组件
    let relateSortCompIndex = pageInstance.data.eles.findIndex((ele) => {
      if (ele.type === 'topic-sort') {
        return ele.param.topic_sort_object == listId;
      }
      return false;
    });
    // 设置话题排序
    if (relateSortCompIndex > -1) {
      let firstSortItem = pageInstance.data.eles[relateSortCompIndex].content[0];
      listParam.orderby = firstSortItem.orderby;
      listParam.order = firstSortItem.order;
    }

    let pageRouter = app.getPageRouter();
    let currentPageTopics = app.globalData.susTopicsMap[pageRouter];
    if (!currentPageTopics) {
      currentPageTopics = app.globalData.susTopicsMap[pageRouter] = [];
    }
    if (topicSuspension.isShow) { // 将有悬浮窗的话题compindex存起来
      if (currentPageTopics.indexOf(compindex) === -1) {
        currentPageTopics.push(compindex);
      }
      if (currentPageTopics.length > 1 && compindex !== currentPageTopics[0]) {
        topicSuspension.isShow = false;
      }
    }

    newdata['eles[' + compindex + '].listParam'] = listParam;
    newdata['eles[' + compindex + '].listStatus'] = listStatus;
    newdata['eles[' + compindex + '].topicSuspension'] = topicSuspension;
    newdata['eles[' + compindex + '].topicPhoneModal'] = topicPhoneModal;
    newdata['eles[' + compindex + '].topicReplyComment'] = topicReplyComment;
    newdata['eles[' + compindex + '].topicReplyParam'] = topicReplyParam;
    pageInstance.setData(newdata);

    if (listParam.orderby === 'distance' && !listParam.latitude) {
      app.getLocation({
        success: function (res) {
          pageInstance.setData({
            ['eles[' + compindex + '].listParam.longitude']: res.longitude,
            ['eles[' + compindex + '].listParam.latitude']: res.latitude
          });
          that.getTopListData(compindex, pageInstance);
        }
      });
    } else {
      this.getTopListData(compindex, pageInstance);
    }
    app.globalData.hasTopicCom = true;
    this.systemInfo = app.getSystemInfo();
    this.getSysnInfoTimer = setTimeout(() => {
      let systemInfo = app.getSystemInfo();
      if (systemInfo.windowHeight !== this.systemInfo.windowHeight) {
        this.systemInfo = systemInfo;
      }
    }, 500);
  }

  getTopListData = (compindex, pageIns, callback) => {
    let that = this;
    let pageInstance = pageIns || app.getAppCurrentPage(),
      listComData = pageInstance.data.eles[compindex],
      listParam = listComData.listParam,
      listStatus = listComData.listStatus,
      topicList = listComData.topicList || [];
    if (listComData.customFeature.isShowList === false) {
      pageInstance.setData({ ['eles[' + compindex + '].topicList']: [] });
      return;
    }
    if (listStatus.loading || !listStatus.isMore) {
      return;
    }
    let newdata = {};
    newdata['eles[' + compindex + '].listStatus.loading'] = true;
    newdata['eles[' + compindex + '].listStatus.loadingFail'] = false;
    if (listParam.page == 1) {
      newdata['eles[' + compindex + '].topicList'] = [];
      newdata['eles[' + compindex + '].listStatus.isMore'] = true;
    }
    pageInstance.setData(newdata);

    if (listParam.orderby === 'distance') { // 距离最近排序需要添加参数order，其他排序不用
      listParam.order = 'asc';
    } else if ('order' in listParam) {
      delete listParam.order;
    }

    app.sendRequest({
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: listParam,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let newdata = {};
        listStatus.loading = false;
        listStatus.isMore = res.is_more == 1;
        listStatus.loadingFail = false;
        res.data.forEach(t => {
          t.comment_box_show = false;
          if (t.content.type == 2) {
            if (t.content.url.article) {
              if (t.content.url.article.type == 1) {
                delete t.content.url.article.body;
              }
              if (t.content.url.article.type == 3) {
                t.content.url.article.cover = app.globalData.cdnUrl + '/zhichi_frontend/static/webapp/images/audio_default.png';
              }
            }
          }
          if (t.form_data.list_recommend && t.form_data.list_recommend.recommend_goods && t.form_data.list_recommend.recommend_goods[0]) {
            let { title, price, cover, id } = t.form_data.list_recommend.recommend_goods[0];
            t.form_data.list_recommend.recommend_goods[0] = {
              name: title,
              price: price,
              image: cover,
              id: id
            };
          }
        });
        topicList = res.current_page > 1 ? topicList.concat(res.data) : res.data;
        newdata['eles[' + compindex + '].topicList'] = topicList;
        newdata['eles[' + compindex + '].listParam.page'] = res.current_page + 1;
        newdata['eles[' + compindex + '].listStatus'] = listStatus;
        pageInstance.setData(newdata);
        typeof callback === 'function' && callback(res.data);
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].listStatus.loading'] = false;
        newdata['eles[' + compindex + '].listStatus.loadingFail'] = true;
        pageInstance.setData(newdata);
      }
    });
  }

  topicEleScrollFunc = (e) => {
    let currentTarget = e.currentTarget,
      dataset = currentTarget.dataset,
      compindex = dataset.compindex;
    this.getTopListData(compindex, null);
  }

  turnToTopicDetail = (e) => {
    e.stopPropagation();
    if (app.globalData.topicTurnToDetail) {
      return;
    }
    app.globalData.topicTurnToDetail = true;
    let currentTarget = e.currentTarget,
      dataset = currentTarget.dataset,
      articlestyle = dataset.articlestyle,
      compindex = dataset.compindex,
      index = dataset.index,
      pageInstance = app.getAppCurrentPage(),
      topic = pageInstance.data.eles[compindex].topicList[index],
      newdata = {};
    newdata['eles[' + compindex + '].topicList[' + index + '].read_count'] = +topic.read_count + 1;
    pageInstance.setData(newdata);
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    app.turnToPage('/informationManagement/pages/communityDetail/communityDetail?detail=' + topic.id + '&articleStyle=' + articlestyle + '&dataLiked=' + topic.is_liked + '&phoneNumber=' + topic.phone + '&sectionid=' + topic.section_id + chainParam);
    app.globalData.topicTurnToDetail = false;
  }

  showTopicPhoneModal = (e) => {
    e.stopPropagation();
    let currentTarget = e.currentTarget,
      dataset = currentTarget.dataset,
      phone = dataset.phone,
      compindex = dataset.compindex,
      pageInstance = app.getAppCurrentPage(),
      topicPhoneModal = pageInstance.data.eles[compindex].topicPhoneModal;
    topicPhoneModal.phone = phone.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1-$2-$3');
    topicPhoneModal.isShow = !topicPhoneModal.isShow;
    pageInstance.setData({ ['eles[' + compindex + '].topicPhoneModal']: topicPhoneModal });
  }

  topicImgLoad = (event) => {
    let pageInstance = app.getAppCurrentPage(),
      owidth = event.target.width,
      oheight = event.target.height,
      path = event.currentTarget.dataset.path,
      style = event.currentTarget.dataset.style,
      oscale = owidth / oheight,
      cwidth = 290,
      cheight = 120,
      ewidth, eheight;

    if (style == 1) {
      cwidth = 240;
    }

    if (oscale > cwidth / cheight) {
      ewidth = cwidth;
      eheight = cwidth / oscale;
    } else {
      ewidth = cheight * oscale;
      eheight = cheight;
    }

    pageInstance.setData({
      [path]: `width:${ewidth}px;height:${eheight}px;`
    });
  }

  showTopicCommentBox = (e) => {
    e.stopPropagation();
    let currentTarget = e.currentTarget,
      dataset = currentTarget.dataset,
      compindex = dataset.compindex,
      index = dataset.index,
      pageInstance = app.getAppCurrentPage(),
      topic = pageInstance.data.eles[compindex].topicList[index],
      commentBoxShow = topic.comment_box_show;
    pageInstance.setData({ ['eles[' + compindex + '].topicList[' + index + '].comment_box_show']: !commentBoxShow });
  }

  topicPerformLikeAct = (e) => {
    e.stopPropagation();
    let that = this,
      currentTarget = e.currentTarget,
      dataset = currentTarget.dataset,
      compindex = dataset.compindex,
      index = dataset.index,
      isliked = dataset.isliked,
      pageInstance = app.getAppCurrentPage(),
      topic = pageInstance.data.eles[compindex].topicList[index];

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/PerformLike',
      data: {
        obj_type: 1,
        obj_id: topic.id
      },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        if (res.status == 0) {
          app.showToast({
            title: isliked == 1 ? '点赞取消' : '点赞成功',
            icon: 'success',
            success: function () {
              pageInstance.setData({ ['eles[' + compindex + '].topicList[' + index + '].comment_box_show']: false });
              that.refreshOneTopicData({ 'articleId': topic.id, index, compindex });
            }
          });
        }
      }
    });
  }

  refreshOneTopicData = (param) => {
    if (!param.articleId || !param.compindex) {
      return;
    }
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: { article_id: param.articleId, page: 1, page_size: 10 },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        if (!res.data.length) {
          return;
        }
        let topic = res.data[0];
        if (topic.form_data.list_recommend && topic.form_data.list_recommend.recommend_goods && topic.form_data.list_recommend.recommend_goods[0]) {
          let { title, price, cover, id } = topic.form_data.list_recommend.recommend_goods[0];
          topic.form_data.list_recommend.recommend_goods[0] = {
            name: title,
            price: price,
            image: cover,
            id: id
          };
        }
        pageInstance.setData({ ['eles[' + param.compindex + '].topicList[' + param.index + ']']: topic });
      },
      fail: function () {
      }
    });
  }

  showTopicReplyComment = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex,
      index
    } = e.currentTarget.dataset;
    let topic = pageInstance.data.eles[compindex].topicList[index];
    if (topic) {
      let {
        section_id,
        id,
        agent_user_token
      } = topic;
      let newdata = {};
      newdata['eles[' + compindex + '].topicReplyParam.section_id'] = section_id;
      newdata['eles[' + compindex + '].topicReplyParam.article_id'] = id;
      newdata['eles[' + compindex + '].topicReplyParam.agent_user_token'] = agent_user_token;
      newdata['eles[' + compindex + '].topicReplyComment.index'] = index;
      newdata['eles[' + compindex + '].topicReplyComment.isShow'] = true;
      newdata['eles[' + compindex + '].topicReplyComment.focus'] = true;
      newdata['eles[' + compindex + '].topicList[' + index + '].comment_box_show'] = false;
      pageInstance.setData(newdata);
    }
  }

  pageBackTopAct = (e) => {
    e.stopPropagation();
    app.pageScrollTo(0);
  }

  turnToTopicPublish = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    pageInstance.communityPublishTypeRef.current.show({
      communityPublishType : {
        show: true
      }
    })
  }

  topicMakePhoneCall = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage(),
      compindex = e.currentTarget.dataset.compindex,
      phone = pageInstance.data.eles[compindex].topicPhoneModal.phone;
    pageInstance.setData({ ['eles[' + compindex + '].topicPhoneModal.isShow']: false });
    app.makePhoneCall(phone);
  }

  goToCommunityPage = (event) => {
    event.stopPropagation();
    let id = event.currentTarget.dataset.id;
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    app.turnToPage('/informationManagement/pages/communityPage/communityPage?detail=' + id + chainParam);
  }

  topicTurnToGoodsDetail = (event) => {
    event.stopPropagation();
    let id = event.currentTarget.dataset.id;
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    app.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + id + chainParam);
  }

  topicReplyInput = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    pageInstance.setData({
      ['eles[' + compindex + '].topicReplyParam.text']: e.target.value
    });
  }

  topicReplyFocus = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    let newdata = {};
    if (e.target.height) {
      let curKbHeight = e.target.height;
      if (/iPhone\s?X/i.test(app.globalData.systemInfo.model)) {
        curKbHeight = 365;
      }
      let hasTabBar = pageInstance.data.eles[compindex].topicReplyComment.hasTabBar;
      if (hasTabBar) { // 暂时无法获取tabBar的高度，默认取54px
        curKbHeight = curKbHeight - 54;
      }
      newdata['eles[' + compindex + '].topicReplyComment.keyboardHeight'] = curKbHeight + 'px';
    }
    newdata['eles[' + compindex + '].topicReplyComment.focus'] = true;
    pageInstance.setData(newdata);
  }

  topicReplyBlur = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    pageInstance.setData({
      ['eles[' + compindex + '].topicReplyComment.focus']: false
    });
  }

  topicReplyLineChange = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    let lineHeight = 40;
    let marginTop = 45;
    let commentContentHeight = lineHeight;
    let maxHeight = pageInstance.data.eles[compindex].topicReplyComment.commentContentMaxHeight;
    // 获取评论框距离页面顶部的高度px
    app.getBoundingClientRect(`#${compindex}-comment-box`, (rect) => {
      if (Array.isArray(rect) && rect[0]) {
        commentContentHeight = e.target.lineCount * lineHeight;
        if (rect[0].top > marginTop && e.target.lineCount >= 1) {
          if (rect[0].top - marginTop <= lineHeight) {
            maxHeight = commentContentHeight + lineHeight;
            pageInstance.setData({
              ['eles[' + compindex + '].topicReplyComment.commentContentMaxHeight']: maxHeight
            })
          }
          pageInstance.setData({
            ['eles[' + compindex + '].topicReplyComment.commentContentHeight']: commentContentHeight
          })
        }
        if (rect[0].top <= marginTop && commentContentHeight <= maxHeight) {
          pageInstance.setData({
            ['eles[' + compindex + '].topicReplyComment.commentContentHeight']: commentContentHeight
          })
        }
      }
    })
  }

  topicReplyImagePreview = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    let commentImage = pageInstance.data.eles[compindex].topicReplyParam.comment_img_url;
    app.previewImage({
      current: commentImage
    });
  }

  topicReplyImageDelete = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    pageInstance.setData({
      ['eles[' + compindex + '].topicReplyParam.comment_img_url']: ''
    });
  }

  topicReplyLocationDelete = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    pageInstance.setData({
      ['eles[' + compindex + '].topicReplyParam.address']: '',
      ['eles[' + compindex + '].topicReplyParam.latitude']: '',
      ['eles[' + compindex + '].topicReplyParam.longitude']: '',
    });
  }

  topicReplyImageChoose = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    app.chooseImage((imageUrls) => {
      pageInstance.setData({
        ['eles[' + compindex + '].topicReplyParam.comment_img_url']: imageUrls
      })
    }, 1);
  }

  topicReplyLocationChoose = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    app.chooseLocation({
      success({ name, address, latitude, longitude }) {
        let newdata = {};
        newdata['eles[' + compindex + '].topicReplyParam.latitude'] = latitude;
        newdata['eles[' + compindex + '].topicReplyParam.longitude'] = longitude;
        if (name || address) {
          newdata['eles[' + compindex + '].topicReplyParam.address'] = name || address;
        } else {
          app.sendRequest({
            hideLoading: true,
            url: '/index.php?r=Map/getAreaInfoByLatAndLng',
            data: {
              latitude: latitude,
              longitude: longitude,
              country_region_id: 1 // 中国
            },
            success: function (res) {
              address = res.data.address || '';
              pageInstance.setData({
                ['eles[' + compindex + '].topicReplyParam.address']: address
              });
            }
          })
        }
        pageInstance.setData(newdata);
      }
    })
  }

  clearCommentInput = (compindex) => {
    let pageInstance = app.getAppCurrentPage();
    pageInstance.setData({
      ['eles[' + compindex + '].topicReplyParam.text']: '',
      ['eles[' + compindex + '].topicReplyParam.agent_user_token']: '',
      ['eles[' + compindex + '].topicReplyParam.address']: '',
      ['eles[' + compindex + '].topicReplyParam.latitude']: '',
      ['eles[' + compindex + '].topicReplyParam.longitude']: '',
      ['eles[' + compindex + '].topicReplyParam.comment_img_url']: '',
      ['eles[' + compindex + '].topicReplyParam.articleId']: ''
    })
  }

  topicCancelReply = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    pageInstance.setData({
      ['eles[' + compindex + '].topicReplyComment.isShow']: false,
      ['eles[' + compindex + '].topicReplyComment.focus']: false
    });
    this.clearCommentInput(compindex);
  }

  topicSubmitReply = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    let that = this,
      {
        topicReplyParam,
        topicReplyComment: {
          index
        }
      } = pageInstance.data.eles[compindex];

    topicReplyParam.text = topicReplyParam.text.trim(); // 去除两端的空格

    if (!topicReplyParam.text) {
      app.showModal({ content: '请填写回复内容' });
      return;
    }

    if (app.globalData.isTopicCommentSubmiting) {
      return;
    }
    app.globalData.isTopicCommentSubmiting = true;

    app.sendRequest({
      url: '/index.php?r=AppSNS/AddComment',
      data: topicReplyParam,
      method: 'post',
      success: function (res) {
        app.showToast({
          title: '回复成功',
          success: function () {
            pageInstance.setData({
              ['eles[' + compindex + '].topicReplyComment.isShow']: false,
              ['eles[' + compindex + '].topicReplyComment.focus']: false
            });
          }
        });
        that.refreshOneTopicData({ articleId: topicReplyParam.article_id, compindex: compindex, index: index });
        that.clearCommentInput();
      },
      complete: function (res) {
        app.globalData.isTopicCommentSubmiting = false;
      }
    });
  }

  topicTurnToUsercenter = (e) => {
    let {
      usertoken,
      sourcetype
    } = e.currentTarget.dataset;
    if (sourcetype === undefined) {
      return;
    }
    app.turnToPage('/informationManagement/pages/communityUsercenter/communityUsercenter?detail=&usertoken=' + usertoken + '&sourcetype=' + sourcetype);
  }

  tapPrevewPictureHandler = (e) => {
    e.stopPropagation();
    app.tapPrevewPictureHandler(e);
  }

  topicSuspensionTouchEvent = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let {
      compindex
    } = e.currentTarget.dataset;
    let topicSuspension = pageInstance.data.eles[compindex].topicSuspension;
    let {
      windowWidth,
      windowHeight
    } = this.systemInfo;
    let {
      clientX,
      clientY
    } = e.touches[0];
    if (e.type === 'touchstart') {
      let {
        offsetLeft,
        offsetTop
      } = e.currentTarget;
      let itemOffsetWidth = windowWidth / 750 * 80,
        itemOffsetHeight = windowWidth / 750 * 100,
        count = topicSuspension.topBtnShow ? 3 : 2;

      this.suspensionStyle = {
        width: itemOffsetWidth,
        height: itemOffsetHeight * count,
        deltX: clientX - offsetLeft,
        deltY: clientY - offsetTop
      };
      return;
    }
    let {
      width,
      height,
      deltX,
      deltY
    } = this.suspensionStyle;
    let leftVal = clientX - deltX;
    let topVal = clientY - deltY;
    let maxLeftVal = windowWidth - width;
    let maxTopVal = windowHeight - height;
    leftVal < 0 && (rightVal = 0);
    leftVal > maxLeftVal && (leftVal = maxLeftVal);
    topVal < 0 && (topVal = 0);
    topVal > maxTopVal && (topVal = maxTopVal);

    pageInstance.setData({
      ['eles[' + compindex + '].topicSuspension.style']: {
        top: transformPx2Rem(topVal),
        left: transformPx2Rem(leftVal),
        bottom: '.40rem',
        right: '.30rem'
      }
    });
  }

  _refreshTopicList = (targetCompIndex, requestData, pageInstance) => {
    let categoryId = requestData.idx_arr.idx_value || '';
    pageInstance.setData({
      [targetCompId + '.listParam.page']: 1,
      [targetCompId + '.listParam.category_id']: categoryId,
      [targetCompId + '.listStatus']: {
        loading: false,
        isMore: true
      }
    });
    this.getTopListData(targetCompIndex, pageInstance);
  }

  mode2articlestyle = (mode) => {
    const convert = {
      0: 2,
      1: 1,
      2: 1,
    }
    return convert[mode];
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    // 商品分类
    const content = data.content;
    // 组件样式
    const styleObj = convertStyleData(data.style);
    
    // TODO: 可能是小程序的bug，应该
    styleObj['backgroundColor'] = '#F2F2F2';

    if (customFeature.vesselAutoheight == 0) {
      styleObj['height'] = transformPx2Rem(height, 320);
    }

    let btnsGroupStyleObj = {};
    if (data.topicSuspension && data.topicSuspension.style) {
      btnsGroupStyleObj = {
        ...convertStyleData(data.topicSuspension.style),
        bottom: transformPx2Rem(app.isTabBarPage() ? (parseInt(data.style.bottom) + 48) : data.style.bottom, 320),
      }
    } else {
      btnsGroupStyleObj = {
        bottom: app.isTabBarPage() ? 'calc(.40rem + 48px)' : '.40rem',
        right: '.30rem'
      };
    }
    // todo 底部导航
    return (
      <div className={`custom-component topic mode-${customFeature.mode}`} style={styleObj}>
        {
          data.topicList && data.topicList.map((item, index) => (
            <div className="topic-item" key={index}
              onClick={this.turnToTopicDetail}
              data-index={index}
              data-compindex={this.props.index}
              data-articlestyle={this.mode2articlestyle(customFeature.mode)}
            >
              {/* 卡片样式 */}
              {
                customFeature.mode == 0 &&
                <React.Fragment>
                  <div className="user">
                    <div className="user-img"
                      onClick={this.topicTurnToUsercenter}
                      data-usertoken={item.user_token}
                      data-sourcetype={item.source_type}
                      >
                      <img src={item.headimgurl} alt="" />
                    </div>
                    <div className="user-info">
                      <span className="author">{item.nickname}</span>
                      <div className="time">{item.add_time}</div>
                    </div>
                  </div>
                  <div className="title">{item.title}</div>
                  <div className="content-text">{item.content.text}</div>
                  {
                    item.content.imgs && item.content.imgs[0] &&
                    <div className="content-img">
                      <img src={item.content.imgs[0]} alt="" />
                    </div>
                  }
                  {
                    item.form_data.list_recommend.recommend_goods && item.form_data.list_recommend.recommend_goods[0] &&
                    <div className="goods"
                      onClick={this.topicTurnToGoodsDetail}
                      data-id={item.form_data.list_recommend.recommend_goods[0].id}
                      data-goods-type={item.form_data.list_recommend.recommend_goods[0].goods_type}
                    >
                      <div className="goods-img">
                        <img src={item.form_data.list_recommend.recommend_goods[0].image} />
                      </div>
                      <div className="goods-dec">
                        <div className="goods-title">{item.form_data.list_recommend.recommend_goods[0].name}</div>
                        <div className="goods-price">¥{item.form_data.list_recommend.recommend_goods[0].price}</div>
                        <span className="ico-moon icon-community-group-arrow"></span>
                      </div>
                    </div>
                  }
                  <div className="bottom">
                    <div className="reading">{item.read_count}阅读量</div>
                    <div className="utils">
                      <div className="thumbs"
                        onClick={this.topicPerformLikeAct}
                        data-compindex={this.props.index}
                        data-index={index}
                        data-isliked={item.is_liked}
                      >
                        <span className="ico-moon icon-community-group-thumb"></span>
                        <span className="num">{item.like_count}</span>
                      </div>
                      <div className="reply"
                        onClick={this.showTopicReplyComment}
                        data-compindex={this.props.index}
                        data-index={index}
                      >
                        <span className="ico-moon icon-goods-customer-service"></span>
                        <span className="num">{item.comment_count}</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              }
              {/* 文章样式 */}
              {
                customFeature.mode == 1 &&
                <React.Fragment>
                  <div className="topic-top">
                    <div className="author-logo" onClick={this.topicTurnToUsercenter} data-usertoken={item.user_token} data-sourcetype={item.source_type}>
                      <img src={item.headimgurl} alt="" />
                    </div>
                    <div className="author-name">{item.nickname}</div>
                    {
                      item.top_flag == 1 &&
                      <span className="topic-stick"></span>
                    }
                    {
                      item.phone &&
                      <span className="contact-ta" data-compindex={this.props.index} data-phone={item.phone} onClick={this.showTopicPhoneModal}></span>
                    }
                    <div className="topic-title">{item.title}</div>
                  </div>
                  <div className="topic-des">{item.content.text || ''}</div>
                  {
                    item.content.type == 2 && item.content.url.article &&
                    <div className="topic-link">
                      <div className="link-logo-wrap">
                        <img className="link-logo" src={item.content.url.article.cover || item.content.url.article.logo} mode="aspectFill" alt="" />
                        {
                          item.content.url.article.type == 4 &&
                          <label className="ico-moon icon-news-video-play"></label>
                        }
                      </div>
                      <span className="link-text">{item.content.url.article.title}</span>
                    </div>
                  }
                  {
                    item.content.type == 2 && item.content.url.video &&
                    <div className="topic-video">
                      <img className="video-cover" src={item.content.url.video.cover || ''} mode="aspectFill" alt="" />
                      <label className="ico-moon icon-news-video-play"></label>
                    </div>
                  }
                  {
                    item.content.imgs && item.content.imgs.length > 0 &&
                    <div className="imgs-list">
                      {
                        item.content.imgs.map((img, imgIdx) => {
                          if (imgIdx < 9) {
                            return <div key={imgIdx} className="img-item">
                              <img src={img} mode="aspectFill" alt="" data-img={img} data-imgarr={JSON.stringify(item.content.imgs)} onClick={this.tapPrevewPictureHandler} />
                            </div>
                          }
                        })
                      }
                    </div>
                  }
                  {
                    item.form_data.list_recommend.recommend_goods && item.form_data.list_recommend.recommend_goods[0] &&
                    <div className="topic-goods" onClick={this.topicTurnToGoodsDetail} data-id={item.form_data.list_recommend.recommend_goods[0].id} data-goods-type={item.form_data.list_recommend.recommend_goods[0].goods_type}>
                      <div className="goods-left">
                        <img src={item.form_data.list_recommend.recommend_goods[0].image} />
                      </div>
                      <div className="goods-center">
                        <div className="goods-name">
                          <span>{item.form_data.list_recommend.recommend_goods[0].name}</span>
                        </div>
                        <div className="goods-price">¥
          <span>{item.form_data.list_recommend.recommend_goods[0].price}</span>
                        </div>
                      </div>
                      <div className="goods-right">
                        <button>去购买</button>
                      </div>
                    </div>
                  }
                  <div className="topic-publish-info">
                    <span className="topic-publish-date">{item.add_time}</span>
                    <span className="topic-publish-address">
                      {
                        item.address &&
                        <i className="ico-moon icon-community-location"></i>
                      }
                      {item.address}
                    </span>
                    <span className="publish-where" onClick={this.goToCommunityPage} data-id={item.section_id}>来自{item.section_name}</span>
                  </div>
                  {/* 此处的评论内容只展示于朋友圈 */}
                  <div className="topic-bottom">
                    {
                      item.comment_count > 0 &&
                      <div className="topic-disscuss">
                        {
                          item.comment.map((co, coIdx) => (
                            <div key={coIdx} className="topic-diss-li">
                              <span className="topic-diss-name">{co.nickname}</span>
                              {
                                co.content.reply_to &&
                                <span>回复</span>
                              }
                              {
                                co.content.reply_to &&
                                <span>{co.content.reply_to.nickname}</span>
                              }
                              ：<span>{co.content.text}</span>
                            </div>
                          ))
                        }
                        <div className="topic-diss-all">
                          查看全部
                          <span className="topic-diss-count">{item.comment_count}</span>
                          条评论
                        </div>
                      </div>
                    }
                  </div>
                  <div className="topic-footer">
                    <span className="topic-share">
                      <i className="ico-moon icon-community_share"></i>
                      <span>{item.spread_count > 0 ? item.spread_count : '分享'}</span>
                    </span>
                    <span className="topic-viewcount">
                      <i className="ico-moon icon-community_view"></i>
                      <span>{item.read_count > 0 ? item.read_count : '浏览'}</span>
                    </span>
                    <span className="topic-rating" data-compindex={this.props.index} data-index={index} onClick={this.showTopicReplyComment}>
                      <i className="ico-moon icon-community_message"></i>
                      <span>{item.comment_count > 0 ? item.comment_count : '评论'}</span>
                    </span>
                    <span className="topic-voteup" data-isliked={item.is_liked} data-compindex={this.props.index} data-index={index} onClick={this.topicPerformLikeAct} style={item.is_liked == 1 ? {color: '#FF4141'} : {}}>
                      <i className={`ico-moon ${item.is_liked == 1 ? 'icon-community_praise_fill' : 'icon-community_praise'}`}></i>
                      <span>{item.like_count > 0 ? item.like_count : '点赞'}</span>
                    </span>
                  </div>
                </React.Fragment>
              }
              {/* 朋友圈样式 */}
              {
                customFeature.mode == 2 &&
                <React.Fragment>
                  <div className="topic-top">
                    <div className="author-logo" onClick={this.topicTurnToUsercenter} data-usertoken={item.user_token}
                      data-sourcetype={item.source_type}>
                      <img src={item.headimgurl} alt="" />
                    </div>
                    <div className="top-right">
                      <div className="author-name">{item.nickname}</div>
                      {
                        item.top_flag == 1 &&
                        <span className="topic-stick"></span>
                      }
                      {
                        item.hot_flag == 1 &&
                        <span className="topic-favorite"></span>
                      }
                      <div className="topic-title">
                        <span onClick={this.goToCommunityPage} data-id={item.section_id} className="publish-where">#{item.section_name}#</span>
                        {item.title}
                      </div>
                    </div>
                  </div>
                  <div className="topic-des">{item.content.text || ''}</div>
                  {
                    item.content.type == 2 && item.content.url.article &&
                    <div className="topic-link">
                      <div className="link-logo-wrap">
                        <img className="link-logo" src={item.content.url.article.cover || item.content.url.article.logo} mode="aspectFill"
                          alt="" />
                        {
                          item.content.url.article.type == 4 &&
                          <label className="ico-moon icon-news-video-play"></label>
                        }
                      </div>
                      <span className="link-text">{item.content.url.article.title}</span>
                    </div>
                  }
                  {
                    item.content.type == 2 && item.content.url.video &&
                    <div className="topic-video">
                      <img className="video-cover" src={item.content.url.video.cover || ''} mode="aspectFill" alt="" />
                      <label className="ico-moon icon-news-video-play"></label>
                    </div>
                  }
                  {
                    item.content.imgs && item.content.imgs.length > 0 &&
                    <div className="imgs-list">
                      {
                        item.content.imgs.map((img, imgIdx) => (
                          <div key={imgIdx} className="img-item">
                            <img src={img} mode="aspectFill" alt="" data-img={img} data-imgarr={JSON.stringify(item.content.imgs)} onClick={this.tapPrevewPictureHandler} />
                          </div>
                        ))
                      }
                    </div>
                  }
                  {/* 目前限定只能添加一个商品 */}
                  {
                    item.form_data.list_recommend.recommend_goods && item.form_data.list_recommend.recommend_goods[0] &&
                    <div className="topic-goods-friend" onClick={this.topicTurnToGoodsDetail}
                      data-id={item.form_data.list_recommend.recommend_goods[0].id} data-goods-type={item.form_data.list_recommend.recommend_goods[0].goods_type}>
                      <div className="goods-left-friend">
                        <img src={item.form_data.list_recommend.recommend_goods[0].image} />
                      </div>
                      <div className="goods-center-friend">
                        <div className="goods-name-friend">
                          <span>{item.form_data.list_recommend.recommend_goods[0].name}</span>
                        </div>
                        <div className="goods-price-friend">
                          <span>¥ {item.form_data.list_recommend.recommend_goods[0].price}</span>
                          <button>购买</button>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="topic-publish-info">
                    <span className="topic-publish-date">{item.add_time}</span>
                    <span className="topic-publish-address">
                      {
                        item.address &&
                        <i className="ico-moon icon-community-location"></i>
                      }
                      {item.address}
                    </span>
                    <span>
                      <span>{item.read_count}阅读量</span>
                    </span>
                    <div className="topic-comment" data-compindex={this.props.index} data-index={index} onClick={this.showTopicCommentBox}>
                      <div className="li-comments">
                        <img src="http://cdn.jisuapp.cn/static/webapp/images/comments.png" />
                      </div>
                      {
                        item.comment_box_show &&
                        <div className="topic-comment-box">
                          <span className="topic-comment-like" data-isliked={item.is_liked} data-compindex={this.props.index}
                            data-index={index} onClick={this.topicPerformLikeAct}>
                            <i className={`ico-moon ${item.is_liked == 1 ? 'icon-community_praise_fill' : 'icon-community_praise'}`}></i>
                            <span>{item.like_count > 0 ? item.like_count : '点赞'}</span>
                          </span>
                          <span className="topic-comment-rating" data-compindex={this.props.index} data-index={index} onClick={this.showTopicReplyComment}>
                            <i className="ico-moon icon-community_message"></i>
                            <span>{item.comment_count > 0 ? item.comment_count : '评论'}</span>
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="topic-bottom">
                    {
                      item.like_count > 0 &&
                      <div className="topic-like-list">
                        <i className="ico-moon icon-community_praise"></i>
                        {
                          item.like.map((like, likeIdx) => (
                            <span key={likeIdx} className="topic-like-text">
                              {
                                likeIdx > 0 &&
                                <span>,</span>
                              }
                              <span>{item.nickname}</span>
                            </span>
                          ))
                        }
                      </div>
                    }
                    {
                      item.comment_count > 0 &&
                      <div className="topic-disscuss">
                        {
                          item.comment.map((co, coIdx) => {
                            <div key={coIdx} className="topic-diss-li">
                              <span className="topic-diss-name">{co.nickname}</span>
                              {
                                co.content.reply_to &&
                                <span style={{
                                  color: '#333'
                                }}>回复</span>
                              }
                              {
                                co.content.reply_to &&
                                <span>{co.content.reply_to.nickname}</span>
                              }
                              : <span>{co.content.text}</span>
                            </div>
                          })
                        }
                        <div className="topic-diss-all-friend">
                          查看全部回复
                          <span className="ico-moon icon-downarrow"></span>
                        </div>
                      </div>
                    }
                  </div>
                </React.Fragment>
              }
            </div>
          ))
        }
        {/* 加载loading */}
        {
          data.listStatus && data.listStatus.loading &&
          <RequestStatus is="requestLoading"></RequestStatus>
        }
        {/* 加载没有数据 */}
        {
          data.listStatus && !data.listStatus.isMore && data.topicList.length == 0 &&
          <RequestStatus is="requestNone" data={{ data: '暂无话题~' }}></RequestStatus>
        }
        {/* 加载失败 */}
        {
          data.listStatus && data.listStatus.loadingFail &&
          <RequestStatus is="requestFail" data={{ refreshEvent: 'topicEleScrollFunc', compindex: this.props.index }}></RequestStatus>
        }
        {/* 加载完所有数据 */}
        {
          data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText &&
          <RequestStatus is="requestAll"></RequestStatus>
        }
        {/* 点击加载按钮 */}
        {
          data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && !!data.listStatus.isMore && !data.listStatus.loading && !data.listStatus.loadingFail &&
          <LoadingBtn customFeature={customFeature} onClick={this.topicEleScrollFunc} data-compindex={this.props.index}></LoadingBtn>
        }
        {
          data.topicSuspension && data.topicSuspension.isShow &&
          <div className="topic-btns-group"
            style={btnsGroupStyleObj}
            data-compindex={this.props.index}>
            {
              data.topicSuspension.topBtnShow &&
              <div className="topic-backtop-btn" data-compindex={this.props.index} onClick={this.pageBackTopAct}>
                <label className="ico-moon icon-community-go-top"></label>
              </div>
            }
            <div className="topic-publish-btn" data-compindex={this.props.index} onClick={this.turnToTopicPublish}>
              <label className="ico-moon icon-community-edit"></label>
            </div>
            <div className="topic-service-btn">
              <label className="ico-moon icon-community-ai"></label>
              {/* TODO：联系客服 */}
              <button onClick={() => customEvent({customFeature: {action: 'contact'}})}></button>
            </div>
          </div>
        }
        {
          data.topicPhoneModal && data.topicPhoneModal.isShow &&
          <div className="actionSheet-wrap">
            <div className="actionSheet-buttons">
              <button className="phoneNum-btn">{data.topicPhoneModal.phone}</button>
              <button className="call-btn" onClick={this.topicMakePhoneCall} data-compindex={this.props.index}>呼叫</button>
              <button className="cancel-btn" data-phone="" onClick={this.showTopicPhoneModal} data-compindex={this.props.index}>取消</button>
            </div>
          </div>
        }
        {
          data.topicReplyComment && data.topicReplyComment.isShow &&
          <div className="comment-mask" data-compindex={this.props.index} onClick={this.topicCancelReply}>
          </div>
        }
        {
          data.topicReplyComment && data.topicReplyComment.isShow &&
          <div className="comment-box" id={`${this.props.index}-comment-box`}
            style={{
              bottom: data.topicReplyComment.focus ? data.topicReplyComment.keyboardHeight : 0
            }}>
            <div className="comment-top">
              <textarea type="textarea" className="comment-input" id="" placeholder={data.topicReplyComment.replyPlaceholder} 
                // TODO 属性待补全
                // placeholder-style="color: #d8d8d8; font-size: 28rpx;"
                maxLength="-1"
                value={data.topicReplyParam.text}
                // focus={data.topicReplyComment.focus}
                // show-confirm-bar="{{false}}"
                // fixed="{{true}}"
                // adjust-position="{{false}}"
                data-compindex={this.props.index} onChange={this.topicReplyInput}
                onFocus={this.topicReplyFocus}
                onBlur={this.topicReplyBlur}
                // bindlinechange="topicReplyLineChange"
                style={{
                  height: `${(data.topicReplyComment.commentContentHeight + 20) / 100}rem`
                }}/>
              {/* 放置图片、位置 */}
              {
                (data.topicReplyParam.comment_img_url || data.topicReplyParam.address) &&
                <div className="comment-others">
                  {
                    data.topicReplyParam.comment_img_url &&
                    <div className="others-image" style={{
                      marginBottom: `${data.topicReplyParam.address ? '0.36' : '0'}rem`
                    }}>
                      <img src={data.topicReplyParam.comment_img_url} mode="aspectFill" data-compindex={this.props.index} onClick={this.topicReplyImagePreview} />
                      <div className="image-close-icon-box" data-compindex={this.props.index} onClick={this.topicReplyImageDelete}>
                        <span className="image-close-icon ico-moon icon-closes"></span>
                      </div>
                    </div>
                  }
                  {
                    data.topicReplyParam.address &&
                    <div className="]others-location" data-compindex={this.props.index} onClick={this.topicReplyLocationDelete}>
                      <span>{data.topicReplyParam.address}</span>
                      <span className="location-close-icon ico-moon icon-closes"></span>
                    </div>
                  }
                </div>
              }
            </div>
            {/* 上传图片按钮、选择位置按钮、发布按钮 */}
            <div className="comment-bottom">
              <div className="comment-bottom-left">
                <span className="comment-bottom-icon ico-moon icon-picture" data-compindex={this.props.index} onClick={this.topicReplyImageChoose}></span>
                <span className="comment-bottom-icon ico-moon icon-community-location" data-compindex={this.props.index} onClick={this.topicReplyLocationChoose}></span>
              </div>
              <div className="comment-bottom-right">
                <div className="comment-bottom-right-cancel" data-compindex={this.props.index} onClick={this.topicCancelReply}>
                  <span>取消</span>
                </div>
                <div className="comment-bottom-right-send" data-compindex={this.props.index} onClick={this.topicSubmitReply}>
                  <span>发布</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom-component/topic-custom-component/TopicCustomComponent.jsx